import React from 'react'

import './modalUtero.scss'
import txtimg from '../../../assets/images/modals/txt-game-2.png'
import person from '../../../assets/images/modals/person-game-2.png'
import instructions from '../../../assets/images/modals/game-2.png'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const ModalUtero = ({ handleCTA }) => {

  return (
    <div className='f-utero-container'>
      <div className='f-utero-container__wrapper'>
        <div className='f-utero-container__content'>

          <div className='f-utero-container__content-img'>
            <h2>Nivel 2</h2>

            <img src={txtimg} className='f-utero-container__content-img-txt' />
            <img src={person} className='f-utero-container__content-img-person' />

          </div>
          <div className='f-utero-container__content-txt'>
            <p>
              En esos días nos sentimos diferentes, <b>¡sí, hay que decirlo!</b>
            </p>

            <p>
              Pero es normal, y hace parte de nuestro ciclo
              menstrual. Por eso, Nosotras tiene productos para que te sientas siempre segura, cómoda y confiada, fuera
              y dentro del periodo.<b> En este juego tendrás que deslizar</b> estos productos hacia la categoría
              correcta.
            </p>


            <div className='f-utero-container__content-txt-img--instructions'>
              <img src={instructions} />

            </div>

            <p className='txt-desktop'>
              Con el mouse haz clic sostenido y arrastra los productos.
            </p>

            <div className='f-utero-container__content-txt-img'>
              <img src={txtimg} className='f-utero-container__content-img-txt--mobile' />

            </div>
            <div className='f-utero-container__content-txt-btn'>
              <button onClick={() => {
                pushEventDataLayer('Personajes :: Juego', 'Nivel 2', 'QUIERO JUGAR')

                handleCTA()
              }}>
                QUIERO JUGAR
              </button>
            </div>
            <div className='f-utero-container__content-txt-img'>
              <img src={person} className='f-utero-container__content-img-person--mobile' />

            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default ModalUtero
